import styled from 'styled-components'
import { BLACK } from '../../styles/colors'
import { GIVONIC, INTER } from '../../styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export const LevelName = styled.span<{ $bold?: boolean }>`
  color: ${BLACK};
  font-family: ${props => props.$bold ? GIVONIC.black : INTER.medium};
  margin-top: 2px;
  font-size: ${props => props.$bold ? '18px' : '14px'};
`
